import { SubscriptionsClient } from '@manifoldxyz/subscriptions-client';

export const SUBSCRIPTION_BACKEND_PROD = 'https://subscriptions.api.manifoldxyz.dev';

export const subscriptionBaseUrl =
  import.meta.env.DEV && import.meta.env.VITE_APP_SUBSCRIPTION_API_URL // must be defined if true
    ? import.meta.env.VITE_APP_SUBSCRIPTION_API_URL
    : `${SUBSCRIPTION_BACKEND_PROD}`;

export const subscriptionApi = new SubscriptionsClient({
  baseUrl: subscriptionBaseUrl,
});
